import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';

// import p1 from 'assests/Photos/ClassAssembly/2024/12B/1.jpg';
// import p2 from 'assests/Photos/ClassAssembly/2024/12B/2.jpg';
// import p3 from 'assests/Photos/ClassAssembly/2024/12B/3.jpg';
// import p4 from 'assests/Photos/ClassAssembly/2024/12B/4.jpg';
// import p5 from 'assests/Photos/ClassAssembly/2024/12B/5.jpg';
// import p6 from 'assests/Photos/ClassAssembly/2024/12B/6.jpg';


// import p7 from 'assests/Photos/ClassAssembly/6D/7.jpg';





import { Typography } from '@mui/material';
import Container from 'components/Container';
import Archive2022 from '../ClassAssembly2023/Archive2022';
import ClassAssemblySidebar2025 from '../ClassAssemblySidebar2025';

const ClassAssembly12A2025 = () => {
  const theme = useTheme();
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);

  const openLightbox = (index) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  };

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };

  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });


  const [config, setConfig] = useState({ base_image_url_2025: '' });
  useEffect(() => {
    fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
      .then(response => response.json())
      .then(data => setConfig(data))
      .catch(error => console.error('Error fetching config:', error));
  }, []);
  
  const p1 = `${config.base_image_url_2025}/home/events-activities/class-assembly/12A/1.webp`;
  const p2 = `${config.base_image_url_2025}/home/events-activities/class-assembly/12A/2.webp`;
  const p3 = `${config.base_image_url_2025}/home/events-activities/class-assembly/12A/3.webp`;
  const p4 = `${config.base_image_url_2025}/home/events-activities/class-assembly/12A/4.webp`;
  const p5 = `${config.base_image_url_2025}/home/events-activities/class-assembly/12A/5.webp`;
  const p6 = `${config.base_image_url_2025}/home/events-activities/class-assembly/12A/6.webp`;
  const p7 = `${config.base_image_url_2025}/home/events-activities/class-assembly/12A/7.webp`;
  const p8 = `${config.base_image_url_2025}/home/events-activities/class-assembly/12A/8.webp`;
  const p9 = `${config.base_image_url_2025}/home/events-activities/class-assembly/12A/9.webp`;
 


  const photos = [
    
    {
      src: p1,
      source: p1,
      rows: 1,
      cols: 1,
    },
    {
      src: p2,
      source: p2,
      rows: 1,
      cols: 1,
    },
    {
        src: p3,
        source: p3,
        rows: 1,
        cols: 1,
      },
       {
      src: p4,
      source: p4,
      rows: 1,
      cols: 1,
    },
    {
        src: p5,
        source: p5,
        rows: 1,
        cols: 1,
      },
      {
        src: p6,
        source: p6,
        rows: 1,
        cols: 1,
      },
       {
      src: p7,
      source: p7,
      rows: 1,
      cols: 1,
    },
    {
        src: p8,
        source: p8,
        rows: 1,
        cols: 1,
      },
      {
        src: p9,
        source: p9,
        rows: 1,
        cols: 1,
      },
      
      
    // {
    //   src: 'https://assets.maccarianagency.com/backgrounds/img21.jpg',
    //   source: 'https://assets.maccarianagency.com/backgrounds/img21.jpg',
    //   rows: 1,
    //   cols: 1,
    // },
  ];

  return (
    <Main>
        <Container>
    <Grid container spacing={4}>
            <Grid item xs={12} md={8}>
    <Box>
        
      <Box >
      <Typography variant='h5' align='center'>
      WORLD ENVIRONMENT DAY: “Heaven Cries, Earth Dies”    
        </Typography>
        <Typography
        fontSize = "x-small"
        ><br/><br/>
 Class: 12A Date: 5 June 2025

        </Typography>

        <br />
        <Typography variant={'subtitle1'} align={'justify'}>
        The students of class 12 A of National Public School, Yeshwanthpur presented their class assembly on World Environment Day titled “Heaven Cries, Earth Dies”, to create awareness, spark reflection and underlined the importance of individual responsibility in curbing plastic pollution. Through their skit which revolved around three elemental deities-Aqua (God of Water), Earth (Goddess of Soil) and Air (Spirit of Wind), the students efficiently conveyed the message: “If we continue to ignore the warnings of nature, we risk losing the very elements that sustain life”. As a commitment to the environment the entire school community took the pledge to reduce, reuse and recycle. Furthermore, the students underscored the initiative to collect unused pages from old notebooks, carefully bind these pages into new usable notebooks- and then donate to underprivileged students who may not have access to school supplies. 
        <br></br>
        The assembly served as a wakeup call for action, inspiring students to become agents of
        change in promoting to curb environmental pollution and reminding that change is
        possible when driven by informed action and collective effort.
        <br></br>
        
        </Typography>
      </Box>
      <Typography
          variant={'h6'}
          color={'primary'}
          align={'center'}
          fontWeight={'normal'}
        ><br/>
   “Clean Earth, Green Earth”

<br/>
        </Typography>

    <Box>
        <ImageList
          variant="quilted"
          cols={2}
          rowHeight={isMd ? 200 : 100}
          gap={isMd ? 16 : 4}
        >
          {photos.map((item, i) => (
            <ImageListItem key={i} cols={item.cols} rows={item.rows}>
              <LazyLoadImage
                height={'100%'}
                width={'100%'}
                src={item.src}
                alt="..."
                effect="blur"
                onClick={() => openLightbox(i)}
                style={{
                  objectFit: 'cover',
                  filter:
                    theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                  cursor: 'poiner',
                  borderRadius: 8,
                }}
              /> 
            </ImageListItem>
          ))}
        </ImageList>
      </Box>
      {viewerIsOpen && (
        <Lightbox
          mainSrc={photos[currentImage].src}
          nextSrc={photos[(currentImage + 1) % photos.length].src}
          prevSrc={
            photos[(currentImage + photos.length - 1) % photos.length].src
          }
          onCloseRequest={() => closeLightbox()}
          onMovePrevRequest={() =>
            setCurrentImage((currentImage + photos.length - 1) % photos.length)
          }
          onMoveNextRequest={() =>
            setCurrentImage((currentImage + 1) % photos.length)
          }
          reactModalStyle={{ overlay: { zIndex: 1500 } }}
        />
      )}
    </Box>
    </Grid>
    <Grid item xs={12} md={4}>
             
             <Box marginBottom={4}>
               <ClassAssemblySidebar2025 />
             </Box>
             <Box marginBottom={4}>
               <Archive2022 />
             </Box>
           {/* <SidebarNewsletter /> */}
         </Grid>
    </Grid> 
    </Container>
    </Main>
   
  );
};

export default ClassAssembly12A2025;